import { createTheme } from '@mui/material/styles';

// Define theme colors
export const themeColors = {
  primary: '#800000',       // Maroon
  primaryLight: '#A52A2A',  // Lighter maroon for hover states
  primaryDark: '#5C0000',   // Darker maroon
  textLight: '#FFFFFF',     // White text for dark backgrounds
  accent: '#D4AF37',        // Gold accent
  bgLight: '#FFF5F5',       // Very light maroon tint for backgrounds
  borderColor: '#DCC0C0',   // Light maroon for borders
  emojiButton: '#faa5a5',
  chartColors: ['#800000', '#A52A2A', '#D4AF37', '#5C0000', '#DCC0C0', '#8B0000', '#B22222', '#CD5C5C']
};

// Create MUI theme
export const theme = createTheme({
  palette: {
    primary: {
      main: themeColors.primary,
      light: themeColors.primaryLight,
      dark: themeColors.primaryDark,
      contrastText: themeColors.textLight,
    },
    secondary: {
      main: themeColors.accent,
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
    subtitle1: {
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 600,
          backgroundColor: '#f8f8f8',
        },
      },
    },
  },
});